import Popup from './Popup';

export const ej = (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0821 3.2085C18.2417 3.20563 21.6888 6.35372 22.0332 10.4148L22.0492 10.66L22.9119 10.6611C24.1931 10.6616 25.2544 11.5971 25.4312 12.8164L25.4503 12.9924L25.457 13.1719V14.829C25.4547 16.1562 24.412 17.2406 23.0933 17.3329L22.9118 17.3393L22.09 17.3392L22.0688 17.5994C21.7654 20.4352 19.76 22.8322 17.0367 23.6542L16.7621 23.7311L16.4924 23.7943L16.4261 23.9287C16.1879 24.3476 15.7552 24.6531 15.2729 24.7549L15.09 24.7834L14.9228 24.7918H13.2412C12.3017 24.7915 11.5382 24.0397 11.5366 23.1088C11.5366 22.2345 12.2147 21.5155 13.0775 21.4339L13.2413 21.4262H14.9228C15.4138 21.4262 15.8712 21.6229 16.1782 21.964L16.2754 22.0852L16.5114 22.0221C18.6318 21.394 20.143 19.5572 20.3434 17.4014L20.3607 17.1513L20.3661 16.8987V11.1017C20.3661 7.69349 17.5479 4.91802 14.0823 4.91802C10.7028 4.91802 7.93884 7.55641 7.80275 10.8477L7.7975 11.1022V15.6562C7.7975 16.5308 7.11947 17.25 6.25701 17.3316L6.09326 17.3393H5.25214C3.91 17.3387 2.80909 16.312 2.71373 15.0079L2.70703 14.8284V13.1714C2.7094 11.8441 3.75205 10.7597 5.0708 10.6674L5.25226 10.6611L6.11486 10.66L6.13154 10.4142C6.46298 6.53393 9.61669 3.49296 13.5254 3.22736L13.8059 3.21313L14.0821 3.2085ZM6.1837 12.3622L5.38946 12.3633C4.9917 12.3633 4.66012 12.6616 4.60312 13.05L4.59446 13.169V14.8314C4.59446 15.2356 4.88989 15.5708 5.27233 15.6283L5.38946 15.6371L6.1837 15.637V12.3622ZM22.7751 12.3633L21.9792 12.3622V15.637L22.7751 15.6371C23.1727 15.6371 23.504 15.3388 23.561 14.9504L23.5696 14.8314V13.169C23.5696 12.7647 23.2742 12.4296 22.8921 12.372L22.7751 12.3633Z"
            fill="white"
        />
    </svg>
);

export const gj = (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4861_13193)">
            <path
                d="M11.7716 4.42181C13.6408 6.29104 13.6408 9.32169 11.7716 11.1909C11.2 11.7625 10.5197 12.1594 9.79725 12.3814L9.79725 17.8765L9.79725 24.5525L6.55251 24.5525L6.55251 12.3814C5.83008 12.1594 5.14981 11.7625 4.57819 11.1909C2.70895 9.32168 2.70896 6.29104 4.57819 4.42181C5.14981 3.85019 5.83006 3.45336 6.55251 3.23135L6.55251 7.52432L9.79725 7.52432L9.79725 3.23135C10.5197 3.45338 11.1999 3.85019 11.7716 4.42181Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5 14.5833C17.5 14.2612 17.7612 14 18.0833 14H21.5833C21.9055 14 22.1667 14.2612 22.1667 14.5833V23.9167C22.1667 24.2388 21.9055 24.5 21.5833 24.5H18.0833C17.7612 24.5 17.5 24.2388 17.5 23.9167V14.5833Z"
                stroke="white"
                strokeWidth="1.5"
            />
            <path
                d="M18.4333 7.7V14H21.2333V7.7L22.1667 6.3L21.2333 3.5H18.4333L17.5 6.3L18.4333 7.7Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_4861_13193">
                <rect width="28" height="28" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const user = (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path
            d="M2.91819 24.6346C2.91819 24.8823 3.12489 25.0831 3.37989 25.0831L24.6174 25.0832C24.8723 25.0832 25.0791 24.8824 25.0791 24.6348V24.0991C25.0897 23.9377 25.1113 23.1322 24.5803 22.2417C24.2455 21.6802 23.7596 21.1951 23.136 20.7999C22.3816 20.3219 21.422 19.9755 20.2613 19.767C20.2527 19.7659 19.392 19.6518 18.5103 19.4266C16.9749 19.0344 16.8407 18.6873 16.8398 18.6839C16.8308 18.6496 16.8177 18.6167 16.801 18.5857C16.7884 18.521 16.7574 18.2773 16.8167 17.6244C16.9674 15.9663 17.8568 14.9863 18.5715 14.1989C18.7969 13.9505 19.0098 13.716 19.1738 13.486C19.8809 12.4937 19.9466 11.3654 19.9495 11.2955C19.9495 11.1538 19.9333 11.0373 19.8984 10.9293C19.829 10.7133 19.6984 10.5786 19.603 10.4804C19.579 10.4556 19.5557 10.4315 19.5371 10.4099C19.5301 10.4017 19.5113 10.38 19.5284 10.2683C19.5911 9.85706 19.6288 9.51278 19.6469 9.18477C19.6791 8.60039 19.7042 7.72644 19.5535 6.87588C19.5349 6.73063 19.5029 6.57721 19.4532 6.39445C19.2939 5.80875 19.0381 5.308 18.6826 4.89473C18.6215 4.82821 17.1351 3.2623 12.8203 2.94101C12.2237 2.89659 11.6339 2.92052 11.0533 2.95019C10.9133 2.95711 10.7217 2.96661 10.5424 3.01307C10.0969 3.12847 9.97803 3.41084 9.94682 3.56887C9.89508 3.83063 9.98602 4.03426 10.0462 4.16902C10.0549 4.18856 10.0657 4.21275 10.0469 4.27565C9.9467 4.43077 9.78914 4.57061 9.62849 4.7031C9.58206 4.74256 8.50009 5.67548 8.44059 6.89419C8.28018 7.82105 8.29231 9.26515 8.48201 10.2632C8.49303 10.3184 8.50931 10.4 8.48288 10.4551C8.27889 10.6379 8.04766 10.8451 8.04824 11.3179C8.05069 11.3654 8.11632 12.4937 8.82355 13.486C8.98735 13.7158 9.20004 13.9502 9.42526 14.1983C10.14 14.9857 11.0299 15.9663 11.1806 17.6244C11.2398 18.2772 11.2088 18.521 11.1963 18.5857C11.1795 18.6166 11.1665 18.6496 11.1575 18.6839C11.1565 18.6873 11.0228 19.0332 9.49439 19.4246C8.61262 19.6504 7.74456 19.7658 7.71866 19.7695C6.59067 19.9599 5.63691 20.2977 4.8839 20.7732C4.26243 21.1657 3.77558 21.6517 3.43687 22.2177C2.8957 23.1219 2.91033 23.9455 2.91819 24.0958V24.6346Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path d="M12.5 20.5L14 18.5L15.5 20.5L14 23.5L12.5 20.5Z" fill="white" />
    </svg>
);

export const Img_List = [
    'https://websiteoss.ecoflow.com/upload/image/1730771529612/img1.png',
    'https://websiteoss.ecoflow.com/upload/image/1730771530235/img2.png',
    'https://websiteoss.ecoflow.com/upload/image/1730771530771/img3.png',
    'https://websiteoss.ecoflow.com/upload/image/1730771530526/img4.png',
    'https://websiteoss.ecoflow.com/upload/image/1730771529977/img5.png',
    'https://websiteoss.ecoflow.com/upload/image/1730771531003/img6.png',
    'https://websiteoss.ecoflow.com/upload/image/1730771529669/img7.png',
];

export const US_Info_Data = {
    tag: 'Launches Dec 10 2024',
    title: 'EcoFlow Power Kits 5kVA 48V Power System',
    desc: 'The first 200 customers* to place an order will become EcoFlow Elite200 Users.',
    tips: [
        'High 5kVA output power, to run 2 × 13500 BTU rooftop a/c units at the same time.',
        'X-Fusion technology, stable electricity and protects appliances even with weak shore power.',
        'As quiet as 48 dB, a volume lower than a quiet office.',
        '45kWh capacity for up to 7 days off-grid.',
        '4 multiple charging methods: shore power, solar, vehicle alternator, and generator.',
        'Charge 11kWh in only 1 hour.',
        'Compact & lightweight, stores easily.',
    ],
    icons: [
        {
            icon: ej,
            title: 'FREE Installation consulting service',
            dialogTitle: (
                <span>
                    <span className="head-title-highlight">FREE</span>
                    <span> Installation consulting service</span>
                </span>
            ),
            desc: 'Based on your vehicle model, our professional sales engineer team will provide a personalized consultation service for the installation of EcoFlow Power Kits 5kVA Power System, recommending solutions that fit your needs.',
            numList: ['Submit Information', 'Confirm Information', 'Schedule Installation', 'Installation by Installer'],
            Popup: Popup,
        },
        {
            icon: gj,
            title: 'Get a chance to win FREE installation**',
        },
        {
            icon: user,
            title: 'Become an EcoFlow Elite200 User',
            dialogTitle: (
                <span>
                    <span className="head-title-highlight">Elite200 User</span>
                    <span> Benefits:</span>
                </span>
            ),
            desc: (
                <span>
                    <span>The first 200 customers* to place an order will become</span>
                    <span className="head-title-highlight"> EcoFlow Elite200 Users.</span>
                </span>
            ),
            list: [
                'Black Knight Limited Edition Power Hub, with engraving on the body: No.X of 1st Edition',
                "Join the Power Kits Elite200 Club***, with priority access to EcoFlow's official customer service team",
                'Become a beta user for future EcoFlow RV series products to get early experience',
            ],
            Popup: Popup,
        },
    ],
};
